
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyInput as SkyInputElement, SkyInputFileSelectedDetail, SkyInputIconClickDetail, SkyInputValidationErrorDetail, SkyInputValueChangedDetail, SkyInputValueClearedDetail } from '@sky.ui/core/sky-input';
 
 

 
 export const SkyInput = createComponent({
   displayName: 'SkyInput',
   react: React,
   tagName: 'sky-input',
   elementClass: SkyInputElement,
   events: {
     
     onValueChanged: 'value-changed' as EventName<CustomEvent<SkyInputValueChangedDetail>>,
     onValueCleared: 'value-cleared' as EventName<CustomEvent<SkyInputValueClearedDetail>>,
     onFileSelected: 'file-selected' as EventName<CustomEvent<SkyInputFileSelectedDetail>>,
     onValidationError: 'validation-error' as EventName<CustomEvent<SkyInputValidationErrorDetail>>,
     onLeftIconClick: 'left-icon-click' as EventName<CustomEvent<SkyInputIconClickDetail>>,
     onRightIconClick: 'right-icon-click' as EventName<CustomEvent<SkyInputIconClickDetail>>,
   }
  });
export type * from '@sky.ui/core/sky-input';
